import React from 'react';
import { Spinner, Badge, Button } from 'react-bootstrap';
import { FaCheck, FaTimes, FaSave } from 'react-icons/fa';

const AutoguardadoIndicator = ({ estado, mensaje, onReintentar, onGuardarAhora }) => {
  if (estado === 'idle' || estado === 'saved') {
    return (
      <Badge bg="light" text="secondary" className="py-2 px-3" style={{borderRadius: '8px'}}>
        <FaCheck className="me-2 text-success" />
        {mensaje || 'Guardado'}
      </Badge>
    );
  }

  if (estado === 'pending') {
    return (
      <div className="d-flex align-items-center gap-2">
        <Badge bg="warning" text="dark" className="py-2 px-3" style={{borderRadius: '8px'}}>
          ● Cambios sin guardar
        </Badge>
        {onGuardarAhora && (
          <Button
            size="sm"
            variant="warning"
            onClick={onGuardarAhora}
            style={{borderRadius: '6px'}}
          >
            <FaSave className="me-1" /> Guardar ahora
          </Button>
        )}
      </div>
    );
  }

  if (estado === 'saving') {
    return (
      <Badge bg="light" className="py-2 px-3" style={{borderRadius: '8px'}}>
        <Spinner animation="border" size="sm" className="me-2" />
        Guardando...
      </Badge>
    );
  }

  if (estado === 'error') {
    return (
      <div className="d-flex align-items-center gap-2">
        <Badge bg="danger" className="py-2 px-3" style={{borderRadius: '8px'}}>
          <FaTimes className="me-2" />
          Error al guardar
        </Badge>
        {onReintentar && (
          <Button
            size="sm"
            variant="outline-danger"
            onClick={onReintentar}
            style={{borderRadius: '6px'}}
          >
            <FaSave className="me-1" /> Reintentar
          </Button>
        )}
      </div>
    );
  }

  return null;
};

export default AutoguardadoIndicator;
